import { defineComponent, computed } from "vue";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "price",
  props: {
    amount: null,
    isHighlight: { type: Boolean },
    isPriceBold: { type: Boolean },
    isWasPrice: { type: Boolean },
    preText: { default: void 0 },
    postText: { default: void 0 },
    theme: { default: void 0 },
    variant: { default: void 0 }
  },
  setup(__props, { expose }) {
    const props = __props;
    const classes = computed(() => {
      const modifier = [];
      if (props.theme) {
        modifier.push(`price--${props.theme}`);
      }
      if (props.variant) {
        modifier.push(`price--variant-${props.variant}`);
      }
      return modifier;
    });
    const preTextClasses = computed(() => {
      const modifier = [];
      if (props.theme)
        modifier.push(`price__amount--${props.theme}`);
      if (props.isHighlight)
        modifier.push("price__pre-text--highlight");
      return modifier;
    });
    const priceClasses = computed(() => {
      const modifier = [];
      if (props.theme)
        modifier.push(`price__amount--${props.theme}`);
      if (props.isWasPrice && props.theme === "light")
        modifier.push("text--strikethrough");
      else if (props.isWasPrice)
        modifier.push("text--strikethrough-primary");
      if (props.isHighlight)
        modifier.push("price__amount--highlight");
      if (props.isPriceBold)
        modifier.push("text--bold");
      return modifier;
    });
    expose({ priceClasses, classes, preTextClasses });
    return { __sfc: true, props, classes, preTextClasses, priceClasses };
  }
});
export {
  _sfc_main as default
};
